import React, { useEffect } from 'react'
import { arrowright, check, line, servicenew, services1, services2, services3, services4, services5, whyus1, whyus2, whyus3 } from '../../assets/imagesPath'
// import { Link } from 'react-router-dom'
import { servicesData } from '../../data/ChooseUsData'
import WhyUsServices from '../../components/ChooseUsCards/WhyUsServices'
import { Link, useLocation } from 'react-router-dom'
import PATHS from '../../routes/Paths'

const Services = () => {

  // const location = useLocation();

  // useEffect(() => {
  //   if (location.state?.section) {
  //     const targetSection = document.getElementById(location.state.section);
  //     if (targetSection) {
  //       targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
  //     }
  //   }
  // }, [location.state]);
  return (
    <>
      <div className='flex items-center justify-center gap-12 mt-[3rem]'>
        <img src={line} alt="" className='h-1 w-7' />
        <p className='text-xl font-bold text-[#818891]'>Services</p>
        <img src={line} alt="" className='h-1 w-7' />
      </div>
      <div id="business-advisory" className="text-center py-10 mediumScreens:py-6 px-4 sm:px-6 lg:px-8">
        <h1 className="text-[4.7rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800">Business Advisory</h1>
      </div>
      <div className="bg-white py-20 px-4 sm:px-6 lg:px-8">
        <div className="w-4/5 smallScreens:w-full mx-auto smallScreens:mx-0 flex flex-col md:flex-row items-center gap-40">
          <div className="w-4/5">
            <div className='flex items-start justify-start'>
              <h1 className='font-bold text-[2.6rem] smallScreens:text-[2rem]'>Personalized Guidance to Drive Your Business Forward</h1>
            </div>
            <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-6 mb-10">
              Running a small business comes with unique challenges, and having the right support makes all the difference. Our Small Business Advisory service provides expert, tailored advice to help you navigate business decisions with confidence.
            </p>
            <div className="flex items-start mb-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Strategic Business Advice
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Receive actionable insights to improve operations, financial health, and growth opportunities.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Customized Solutions
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  We work closely with you to address your specific challenges and goals.
                </p>
              </div>
            </div>
            <div className="flex items-start mt-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Proactive Support
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Get ongoing guidance to overcome roadblocks and optimize your business for success.
                </p>
              </div>
            </div>

          </div>
          <div className="w-full md:w-2/3 relative smallScreens:px-8">
            <img
              src={services1}
              alt="Professional"
              className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain"
            />
          </div>
        </div>

        <div className='flex items-start justify-start gap-6 mt-8 py-6 ml-60'>
          <Link to={PATHS.businessAdvisory}>
            <button className='rounded-full text-[#173363] border border-[#173363] bg-transparent px-12 py-3 text-[1.6rem] smallScreens:rounded-xl smallScreens:px-16 smallScreens:py-1'>Learn More</button>
          </Link>
        </div>
      </div>

      <section id="bookkeeping" className=" bg-[#F2F2F282] text-center pt-6 px-4 sm:px-6 lg:px-8 section">
        <h1 className="text-[5.5rem] md:text-[3.4rem] smallScreens:text-[2.6rem] font-bold text-gray-800">Bookkeeping</h1>
      </section>

      <div className="bg-[#F2F2F282] py-20 px-4 sm:px-6 lg:px-8">
        <div className="w-4/5 mx-auto flex flex-col md:flex-row items-center gap-40">
          <div className="w-full md:w-2/3 relative">
            <img
              src={services2}
              alt="Professional"
              className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain"
            />
          </div>
          <div className="w-4/5 smallScreens:w-full">
            <div className='flex items-start justify-start'>
              <h1 className='font-bold text-[2.4rem]'>Simplified Bookkeeping for Startups and Emerging Businesses</h1>
            </div>
            <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10">
              Starting a business is exciting, but managing the numbers can quickly become overwhelming. Our Cash Basis Bookkeeping service is designed specifically for new and emerging businesses, giving you clarity and control over your finances.
            </p>
            <div className="flex items-start mb-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Organized Financial Records
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Stay on top of your income, expenses, and cash flow with clean, accurate records.
                </p>
              </div>
            </div>
            <div className="flex items-start mb-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Hassle-Free Setup
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  We’ll set up your books, making it easy for you to focus on growing your business.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Reports Tailored for You
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Receive straightforward financial reports that help you make informed decisions.
                </p>
              </div>
            </div>
          </div>

        </div>
      </div>

      <section id="establish-business" className="text-center pt-6 px-4 sm:px-6 lg:px-8 section">
        <h1 className="text-[5.5rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800">Established Business</h1>
      </section>

      <div className="bg-white py-6 smallScreens:py-4 px-4 sm:px-6 lg:px-8">
        <div className="w-4/5 mx-auto flex flex-col md:flex-row items-center gap-40">
          <div className="w-4/5 smallScreens:w-full">
            <div className='flex items-start justify-start mt-6'>
              <h1 className='font-bold text-[2.7rem] smallScreens:text-[2rem]'>Transform Your Business with Strategic Guidance </h1>
            </div>
            <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10">
              Feeling stuck in your business? Our Business Mastery Program is designed to help you break through barriers and scale to new heights. This program combines expert advice and personalized coaching.
            </p>
            <div className="flex items-start mb-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Key Business Skills
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Learn how to manage finances and build a growth strategy.
                </p>
              </div>
            </div>
            <div className="flex items-start mb-10">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Expert Insights
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Direct access to seasoned entrepreneurs, financial advisors, and industry experts.
                </p>
              </div>
            </div>
            <div className="flex items-start">
              <div>
                <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                  Networking Opportunities
                </h3>
                <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                  Connect with peers to share solutions, ideas, and strategies.
                </p>
              </div>
            </div>
          </div>
          <div className="w-full md:w-2/3 relative ">
            <img
              src={services3}
              alt="Professional"
              className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain mt-40"
            />
          </div>
        </div>
      </div>

      <section id="business-formation-support" className="bg-[#F2F2F282] text-center pt-6 px-4 sm:px-6 lg:px-8 section">
      <h1 className="text-[5.5rem] md:text-[3.4rem] smallScreens:text-[2.6rem] font-bold text-gray-800">
        Business Formation Support
      </h1>
    </section>

    <div className="bg-[#F2F2F282] py-10 px-4 sm:px-6 lg:px-8">
      <div className="w-4/5 mx-auto flex flex-col md:flex-row items-center gap-40">
        <div className="w-full relative">
          <img
             src={servicenew}
            alt="Business Formation Support"
            // className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain"
            className='rounded-lg pb-72'
          />
        </div>
        <div className="w-4/5 smallScreens:w-full">
          <div className="flex items-start justify-start mt-6">
            <h1 className="font-bold text-[2.4rem]">
              Start Your Business with Confidence
            </h1>
            
          </div>
          <p className="text-[#64666C] leading-relaxed text-[1.6rem] my-4">
            Our <strong>Business Formation Support</strong> services are designed to help tradespeople—electricians, plumbers, remodelers, and other subcontractors—set up their businesses for success. Whether you’re starting a new LLC or transitioning to an S Corp, we handle the paperwork, ensure compliance, and provide expert guidance tailored to your trade. Plus, you’ll receive personalized support from a <strong>dedicated bookkeeper and advisor</strong> every step of the way.
          </p>
          <div className="flex items-start mb-6">
            <div>
              <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                Business Structure Consultation
              </h3>
              <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                Receive expert guidance on whether an LLC, S Corp, or another structure best suits your business goals.
              </p>
            </div>
          </div>
          <div className="flex items-start mb-6">
            <div>
              <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                State and Federal Compliance
              </h3>
              <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                We handle your business registration, obtain your EIN, and ensure compliance with all relevant state and federal regulations.
              </p>
            </div>
          </div>
          <div className="flex items-start mb-6">
            <div>
              <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                Customized Operating Agreements
              </h3>
              <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                Operating agreements specifically designed for trades businesses with five or less employees.
              </p>
            </div>
          </div>
          <div className="flex items-start mb-6">
            <div>
              <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                Dedicated Bookkeeper and Advisor
              </h3>
              <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                Work one-on-one with a dedicated bookkeeper and advisor to ensure your business starts strong and stays on track.
              </p>
            </div>
          </div>
          <div className="flex items-start">
            <div>
              <h3 className="text-[2rem] font-semibold text-gray-900 mb-2">
                Ongoing Support
              </h3>
              <p className="text-gray-600 leading-relaxed text-[1.6rem] mt-4">
                Access to continuous advisory services, including growth strategies, tax planning, and cash flow management after your business is set up.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>



      <div className='bg-white '>
        <div className='flex items-center justify-center gap-12 py-6 mt-10'>
          <img src={line} alt="" className='h-1 w-7' />
          <p className='text-xl font-bold text-[#818891]'>CHOOSE US</p>
          <img src={line} alt="" className='h-1 w-7' />
        </div>

        <div className='flex items-center justify-center'>
          <h1 className='font-bold text-[3.4rem] text-center w-2/5 smallScreens:text-[2rem] smallScreens:w-full'>Why Choose Us</h1>
        </div>
        <div className=" py-20 px-4  lg:px-8 smallScreens:px-4">
          <div className="max-w-[1250px]  mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
            {servicesData.map((card, index) => (
              <WhyUsServices
                key={index}
                imageSrc={card.imageSrc}
                title={card.title}
                description={card.description}
                linkHref={card.linkHref}
              />
            ))}

          </div>
        </div>


      </div>
    </>
  )
}

export default Services
